import { css } from '@emotion/react';
import BrandedLogo from '../BrandedLogo';
import Container from '../Container';
import { LegalFooterMobile } from '../LegalFooter';
import mobileContainerHeightCSS from '../../constants/mobileContainerHeightCSS';

const PageContainerMobile = ({ title, children }) => {
    return (
        <div
            css={css`
                display: flex;
                overflow: scroll;
                flex-direction: column;
                align-items: center;
                ${mobileContainerHeightCSS}
            `}
        >
            <div
                css={css`
                    max-width: 548px; // border-box with 24px padding, so 500px + 48px
                    box-sizing: border-box;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 2rem;
                    flex-grow: 1;

                    & > div:last-of-type {
                        margin-top: 3.333rem;
                    }

                    &:has(.vaultsPage) {
                        padding: 0;

                        & > div:last-of-type {
                            padding: 0 2rem 2rem;
                            width: auto;
                        }
                    }
                `}
            >
                <div
                    css={css`
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 1.5rem;

                        & > div:first-of-type {
                            margin-bottom: 3.333rem;
                            justify-content: center;
                        }

                        &:has(.vaultsPage) {
                            padding-top: 2rem;
                        }
                    `}
                >
                    <BrandedLogo />
                    <Container>
                        {title && (
                            <h1
                                css={({ black }) => {
                                    return css`
                                        font-size: 2rem;
                                        font-weight: bold;
                                        color: ${black};
                                        margin: 0;
                                    `;
                                }}
                            >
                                {title}
                            </h1>
                        )}
                        <main
                            css={css`
                                width: 100%;
                            `}
                        >
                            {children}
                        </main>
                    </Container>
                </div>
                <LegalFooterMobile />
            </div>
        </div>
    );
};

export default PageContainerMobile;
